import type { RouteLocationNormalized } from 'vue-router'
import { PERMISSIONS, PMO_WEEKLY_CHECK_IN_ALL_PERMISSIONS } from '@/constants/permissions'

/**
 * Weekly Check-In module: Spatie PMO permissions only (no team-profile bypass).
 * Aligns with strict UI: sidebar and routes require a PMO grant; API may still allow team-tree via `canViewModule`.
 */
export function canAccessWeeklyCheckInModuleFromStore(authStore: {
  hasPermission: (p: string) => boolean
  hasAnyPermission: (p: string[]) => boolean
  hasRole: (r: string) => boolean
  user: unknown
}): boolean {
  if (!authStore.user) return false
  if (authStore.hasRole('super-admin')) return true
  if (authStore.hasPermission(PERMISSIONS.SYSTEM.SUPER_ADMIN)) return true
  return authStore.hasAnyPermission([...PMO_WEEKLY_CHECK_IN_ALL_PERMISSIONS])
}

/** Dashboard route access; aligns with API `WeeklyCheckInAuthorizationService::canAccessDashboard`. */
export function hasWeeklyCheckInAdminCapabilitiesFromStore(authStore: {
  hasPermission: (p: string) => boolean
  hasRole: (r: string) => boolean
}): boolean {
  if (authStore.hasRole('super-admin')) return true
  if (authStore.hasPermission(PERMISSIONS.SYSTEM.SUPER_ADMIN)) return true
  return (
    authStore.hasPermission(PERMISSIONS.PMO.DASHBOARD.VIEW) ||
    authStore.hasPermission(PERMISSIONS.PMO.DASHBOARD.VIEW_ALL)
  )
}

/** Routes that use `weeklyCheckInModule` meta; path fallback if meta is missing on `matched` (Vue Router merge edge cases). */
export function isWeeklyCheckInModuleNavigation(to: RouteLocationNormalized): boolean {
  if (to.meta.weeklyCheckInModule === true) return true
  if (to.matched.some((record: { meta?: { weeklyCheckInModule?: boolean } }) => record.meta?.weeklyCheckInModule === true))
    return true
  const p = to.path
  return (
    p === '/project-management/dashboard' ||
    p === '/project-management/weekly-check-in' ||
    p.startsWith('/project-management/weekly-check-in/coordinator/') ||
    p.startsWith('/project-management/weekly-check-in/print/') ||
    p.startsWith('/project-management/weekly-check-in/dashboard/print')
  )
}
